var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgKaddexLoading = function SvgKaddexLoading(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 27,
    viewBox: "0 0 161 27",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4371 10.4355V15.6152H13.0524V18.2305H15.6422V20.8203H18.2321V23.4355H20.8473V26.0254H13.0524V23.4355H10.4371V20.8203H7.84729V18.2305H5.25745V26.0254H0.0523682V0.0253906H5.25745V7.82031H7.84729V5.23047H10.4371V2.64062H13.0524V0.0253906H20.8473V2.64062H18.2321V5.23047H15.6422V7.82031H13.0524V10.4355H10.4371Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2724 5.23047H48.8623V26.0254H43.6826V26H33.2724V26.0254H28.0674V5.23047H30.6826V2.64062H33.2724V0.0253906H43.6826V2.64062H46.2724V5.23047ZM43.708 7.82031H41.0928V5.20508H35.8877V7.82031H33.2978V21H43.708V7.82031Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2874 5.20508H76.8773V20.7949H74.2874V23.4102H71.6722V26H56.0824V0H71.6722V2.61523H74.2874V5.20508ZM71.6722 5.20508H61.2874V20.7949H71.6722V5.20508Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M102.302 5.20508H104.892V20.7949H102.302V23.4102H99.6872V26H84.0974V0H99.6872V2.61523H102.302V5.20508ZM99.6872 5.20508H89.3025V20.7949H99.6872V5.20508Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M132.907 0V5.20508H117.317V10.4102H130.317V13H127.702V15.6152H117.317V20.7949H132.907V26H112.112V0H132.907Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M160.922 0.0253906V7.82031H158.332V10.4355H155.743V13.0254H153.127V15.6152H155.743V18.2305H158.332V20.8203H160.922V26.0254H155.743V23.4355H153.127V20.8203H147.922V23.4355H145.332V26.0254H140.127V20.8203H142.743V18.2305H145.332V15.6152H147.922V13.0254H145.332V10.4355H142.743V7.82031H140.127V0.0253906H145.332V5.23047H147.922V7.82031H153.127V5.23047H155.743V0.0253906H160.922Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_576_5875",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 161,
    height: 27
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4371 10.4355V15.6152H13.0524V18.2305H15.6422V20.8203H18.2321V23.4355H20.8473V26.0254H13.0524V23.4355H10.4371V20.8203H7.84729V18.2305H5.25745V26.0254H0.0523682V0.0253906H5.25745V7.82031H7.84729V5.23047H10.4371V2.64062H13.0524V0.0253906H20.8473V2.64062H18.2321V5.23047H15.6422V7.82031H13.0524V10.4355H10.4371Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2724 5.23047H48.8623V26.0254H43.6826V26H33.2724V26.0254H28.0674V5.23047H30.6826V2.64062H33.2724V0.0253906H43.6826V2.64062H46.2724V5.23047ZM43.708 7.82031H41.0928V5.20508H35.8877V7.82031H33.2978V21H43.708V7.82031Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2874 5.20508H76.8773V20.7949H74.2874V23.4102H71.6722V26H56.0824V0H71.6722V2.61523H74.2874V5.20508ZM71.6722 5.20508H61.2874V20.7949H71.6722V5.20508Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M102.302 5.20508H104.892V20.7949H102.302V23.4102H99.6872V26H84.0974V0H99.6872V2.61523H102.302V5.20508ZM99.6872 5.20508H89.3025V20.7949H99.6872V5.20508Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M132.907 0V5.20508H117.317V10.4102H130.317V13H127.702V15.6152H117.317V20.7949H132.907V26H112.112V0H132.907Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M160.922 0.0253906V7.82031H158.332V10.4355H155.743V13.0254H153.127V15.6152H155.743V18.2305H158.332V20.8203H160.922V26.0254H155.743V23.4355H153.127V20.8203H147.922V23.4355H145.332V26.0254H140.127V20.8203H142.743V18.2305H145.332V15.6152H147.922V13.0254H145.332V10.4355H142.743V7.82031H140.127V0.0253906H145.332V5.23047H147.922V7.82031H153.127V5.23047H155.743V0.0253906H160.922Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_576_5875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38 18V0L31.5 -3L24.5 0L26.5 27.5L34 20.5L38 18Z",
    fill: "#ED1CB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 18V0L44.5 -3L51.5 0L49.5 27.5L42 20.5L38 18Z",
    fill: "#39FFFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 16L49.5 28L26.5 27.5L38 16Z",
    fill: "#FFA900"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKaddexLoading, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/kaddex-loading.42116d36.svg";
export { ForwardRef as ReactComponent };